export default "__VITE_ASSET__B7U$cx9M__"